export const getFromLocalStorage = (key = '') => {
    return localStorage.getItem(key);
}

export const setToLocalStorage = (key, value) => {
    if (key && value !== undefined && value !== null) {
        localStorage.setItem(key, value);
    }
}